import { useQuery } from "@tanstack/react-query";
import Api from "src/Config";
import {
  createContext,
  FunctionComponent,
  ReactElement,
  useContext,
  useMemo,
} from "react";
import { GetUserProfileContext } from "../UserProfile";

export const MonitorOngoingBulkCheckContext = createContext(null);

type Props = {
  children: ReactElement;
};

const MonitorOngoingBulkCheckProvider: FunctionComponent<Props> = ({
  children,
}) => {
  const { data: userData } = useContext(GetUserProfileContext);

  const { data, isLoading, isFetching } = useQuery({
    queryKey: ["ongoing_bulk_check"],
    refetchInterval: 5 * 60 * 1000,
    staleTime: 0,
    enabled: userData && userData?.organisation?.has_bulk_process_running,
    queryFn: async () => {
      const {
        data: { data },
      } = await Api.get(`onboarding/bulk/ongoing-verification`);

      return data;
    },
  });

  const contextValue = useMemo(
    () => ({
      data,
      isLoading,
      isFetching,
    }),
    [data, isLoading, isFetching],
  );
  return (
    <MonitorOngoingBulkCheckContext.Provider value={contextValue}>
      {children}
    </MonitorOngoingBulkCheckContext.Provider>
  );
};

export default MonitorOngoingBulkCheckProvider;
